import React from "react";
import styles from "./EditDesignTemplateItem.module.scss";
import { IDesignTemplate } from "../utils/designTemplates";
import { ISite, ISiteV2 } from "../../../interfaces/Site";
import { siteHasDesignTemplate } from "../utils/siteHasDesignTemplate";
import { GeneratorSitePreview } from "../../../views/GeneratorSite/GeneratorSitePreview";
import { GeneratorSitePreviewScaleSetter } from "../../../views/GeneratorSite/components/GeneratorSitePreviewScaleSetter/GeneratorSitePreviewScaleSetter";
import { isSiteV2 } from "../../../utils/isSiteV2";

interface IProps {
    designTemplate: IDesignTemplate;
    setDesignTemplate: (designTemplate: IDesignTemplate) => void;
    site: ISite | ISiteV2;
    calculateScale: boolean;
}

export const EditDesignTemplateItem = (props: IProps) => {
    const designTemplate = props.designTemplate;

    if (!isSiteV2(props.site)) {
        designTemplate.eventLogo = null;
    }

    return (
        <div
            className={`${styles.wrapper} ${siteHasDesignTemplate(props.site, designTemplate) ? styles.active : ""}`}
            onClick={() => props.setDesignTemplate(designTemplate)}
            data-test-id={"design-template-selector-" + designTemplate?.name}
            data-test-design-template-name={designTemplate?.name}
            tabIndex={0}
        >
            {props.calculateScale ? (
                <GeneratorSitePreviewScaleSetter scaleCssVariableName="--site-preview-scale-edit-design-template" />
            ) : null}
            <div className={styles.inner}>
                <GeneratorSitePreview
                    designTemplate={designTemplate}
                    scaleCssVariableName="--site-preview-scale-edit-design-template"
                />
            </div>
        </div>
    );
};
